import https from "./https-common";

const getAllBanner = (shopDomain) => {
  let shop = shopDomain.replace(".myshopify.com", "");
  shop = shop.replace("https://", "");
  return https.get(`/banners?shop=${shop}`);
};

const BannerService = {
  getAllBanner,
};

export default BannerService;
